import { TableHead, TableRow, TableCell, Checkbox, Box, IconButton, Menu, MenuItem } from '@mui/material'
import MoreVertIcon from '@mui/icons-material/MoreVert'
import SortingIcon from '../SortingIcon'

const TableHeader = ({
  isHeaderCheckboxChecked,
  handleCheckAllCurrentPage,
  handleUncheckAllCurrentPage,
  handleClickCheckAllDropdown,
  handleCloseCheckAllDropdown,
  anchorEl,
  openAnchorEl,
  handleSortChange,
  sortConfig
}) => {

  return (
    <TableHead className='tasksTableHeader'>
      <TableRow>
        <TableCell className='tasksTableHeaderCheckboxCell'>
          <Checkbox
            className='tasksTableHeaderCheckbox'
            checked={isHeaderCheckboxChecked}
            onChange={(e) => {
              const allChecked = e.target.checked
              if (allChecked) {
                handleCheckAllCurrentPage()
              } else {
                handleUncheckAllCurrentPage()
              }
            }}
          />
          <IconButton
            onClick={handleClickCheckAllDropdown}
            size="small"
            sx={{ p: 0 }}
          >
            <MoreVertIcon />
          </IconButton>
          <Menu
            anchorEl={anchorEl}
            open={openAnchorEl}
            onClose={handleCloseCheckAllDropdown}
          >
            <MenuItem onClick={handleCheckAllCurrentPage} sx={{ minWidth: '100px' }}>All</MenuItem>
            <MenuItem onClick={handleUncheckAllCurrentPage}>None</MenuItem>
          </Menu>
        </TableCell>
        <TableCell className='tasksTableHeaderCell taskType' onClick={() => handleSortChange('task_type')}>
          <Box className="tasksTableHeaderCellContent">
            <SortingIcon sortConfig={sortConfig} currentKey={'task_type'}/>
            Task Type
          </Box>
        </TableCell>
        <TableCell className='tasksTableHeaderCell pageName' onClick={() => handleSortChange('page_name')}>
          <Box className="tasksTableHeaderCellContent">
            <SortingIcon sortConfig={sortConfig} currentKey={'page_name'}/>
            Page Name
          </Box>
        </TableCell>
        <TableCell className='tasksTableHeaderCell' onClick={() => handleSortChange('created_by')}>
          <Box className="tasksTableHeaderCellContent">
            <SortingIcon sortConfig={sortConfig} currentKey={'created_by'}/>
            Created by
          </Box>
        </TableCell>
        <TableCell className='tasksTableHeaderCell taskStarted' onClick={() => handleSortChange('started_at')}>
          <Box className="tasksTableHeaderCellContent">
            <SortingIcon sortConfig={sortConfig} currentKey={'started_at'}/>
            Started
          </Box>
        </TableCell>
        <TableCell className='tasksTableHeaderCell taskRunTime' onClick={() => handleSortChange('run_time')}>
          <Box className="tasksTableHeaderCellContent">
            <SortingIcon sortConfig={sortConfig} currentKey={'run_time'}/>
            Run Time
          </Box>
        </TableCell>
        <TableCell className='tasksTableHeaderCell taskStatus' onClick={() => handleSortChange('status')}>
          <Box className="tasksTableHeaderCellContent">
            <SortingIcon sortConfig={sortConfig} currentKey={'status'}/>
            Status
          </Box>
        </TableCell>
        <TableCell className='tasksTableHeaderCell taskDetails'>
          <Box className="tasksTableHeaderCellContent">
            Details
          </Box>
        </TableCell>
        <TableCell className='tasksTableHeaderCell taskError' onClick={() => handleSortChange('error')}>
          <Box className="tasksTableHeaderCellContent">
            <SortingIcon sortConfig={sortConfig} currentKey={'error'}/>
            Error
          </Box>
        </TableCell>
        <TableCell className='tasksTableHeaderCell taskActions'>
          <Box className="tasksTableHeaderCellContent">
            Actions
          </Box>
        </TableCell>
      </TableRow>
    </TableHead>
  )
}

export default TableHeader
